module.exports = __webpack_public_path__ + "media/dashboard/assets/images/kata/badge-mau-85e64b0c1d9aa94b7e8e32bba9c339cd.svg";